import * as React from "react";
import {FC} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {Box, Grid} from "@mui/material";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-handlebars";
import "ace-builds/src-noconflict/theme-tomorrow";

import {FormData} from "../types/MailTypes";
import {FormInputText} from "../../../shop/wholesale/form/FormInputText";

type HTMLEditorProps = {
  mailIndex: number
}

export const HTMLEditor: FC<HTMLEditorProps> = ({mailIndex}) => {
  const form = useFormContext<FormData>();
  const {control} = form;

  return (
    <Box sx={{width: '100%'}}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <FormInputText name={`mails.${mailIndex}.htmlMail.from.name`} label={"Name of sender"}/>
        </Grid>
        <Grid item xs={6}>
          <FormInputText name={`mails.${mailIndex}.htmlMail.from.mail`} label={"Mail of sender"}/>
        </Grid>
      </Grid>
      <FormInputText name={`mails.${mailIndex}.htmlMail.subject`} label={"Subject"}/>
      <Controller
        control={control}
        name={`mails.${mailIndex}.htmlMail.html`}
        defaultValue={""}
        render={({field: {onChange, value}}) => {
          return <AceEditor
            height={"400px"}
            mode="handlebars"
            theme="tomorrow"
            value={value || ''}
            onChange={onChange}
            name="htmlEditor"
            editorProps={{$blockScrolling: true}}
            placeholder={"Mail content"}
            width={"100%"}
          />
        }}
      />
    </Box>
  );
}